import React from 'react';

import { AlertModalTypes, alertsTestIDs } from '@constants';

import { AlertDisconnected } from '../../components/alerts/AlertDisconnected/AlertDisconnected';
import { AlertExit } from '../../components/alerts/AlertExit/AlertExit';
import { AlertLiveANF } from '../../components/alerts/AlertLiveANF/AlertLiveANF';
import { AlertLocation } from '../../components/alerts/AlertLocation/AlertLocation';
import { AlertOverlay } from '../../components/alerts/AlertOverlay/AlertOverlay';
import { AlertShowDescription } from '../../components/alerts/AlertShowDescription/AlertShowDescription';

export const propertiesPage = type => {
  switch (type) {
    case AlertModalTypes.exit:
      return {
        childIds: [alertsTestIDs.exit.buttonNo, alertsTestIDs.exit.buttonYes],
        firstFocus: alertsTestIDs.exit.buttonNo,
      };
    case AlertModalTypes.overlay:
      return {
        childIds: [
          alertsTestIDs.overlay.dismissButton,
          alertsTestIDs.overlay.viewRadarButton,
          alertsTestIDs.overlay.headlineText,
          alertsTestIDs.overlay.subText,
        ],
        firstFocus: alertsTestIDs.overlay.viewRadarButton,
      };
    case AlertModalTypes.location:
      return {
        childIds: [
          alertsTestIDs.location.itsCorrectButton,
          alertsTestIDs.location.changeLocationButton,
          alertsTestIDs.location.headlineText,
          alertsTestIDs.location.helpText,
          alertsTestIDs.location.locationText,
        ],
        firstFocus: alertsTestIDs.location.itsCorrectButton,
      };
    case AlertModalTypes.disconnected:
      return {
        childIds: [alertsTestIDs.disconnected.okButton],
        firstFocus: alertsTestIDs.disconnected.okButton,
      };
    case AlertModalTypes.showDescription:
      return {
        childIds: [
          alertsTestIDs.pdpDescription.focusHandle,
          alertsTestIDs.pdpDescription.description,
          alertsTestIDs.pdpDescription.showTitle,
          alertsTestIDs.pdpDescription.scrollView,
        ],
        firstFocus: alertsTestIDs.pdpDescription.focusHandle,
      };
    case AlertModalTypes.liveANF:
      return {
        childIds: [
          alertsTestIDs.liveANF.liveTitle,
          alertsTestIDs.liveANF.optInTitle,
          alertsTestIDs.liveANF.watchNowButton,
          alertsTestIDs.liveANF.cancelButton,
          alertsTestIDs.liveANF.gotItButton,
        ],
        firstFocus: alertsTestIDs.liveANF.watchNowButton,
      };
    default:
      return null;
  }
};

export const selectAlert = (type, navigation, data) => {
  switch (type) {
    case AlertModalTypes.exit:
      return <AlertExit navigation={navigation} />;
    case AlertModalTypes.overlay:
      return <AlertOverlay navigation={navigation} />;
    case AlertModalTypes.location:
      return <AlertLocation navigation={navigation} />;
    case AlertModalTypes.disconnected:
      return <AlertDisconnected navigation={navigation} />;
    case AlertModalTypes.showDescription:
      return <AlertShowDescription data={data} navigation={navigation} />;
    case AlertModalTypes.liveANF:
      return <AlertLiveANF data={data} navigation={navigation} />;
    default:
      return null;
  }
};
